import { Injectable } from '@angular/core';
import {CanActivate, Router, RouterStateSnapshot, ActivatedRouteSnapshot} from '@angular/router';
import { NotificationsService, TranslationKey, SessionStorageService, TokenService, StorageKey } from './shared';
import { TranslocoService } from '@ngneat/transloco';
import { ITokenResponseData } from './api';
import { AppConstants } from './app.constants';

@Injectable()
//service to guard unauthorised login access
export class AppRoutingGuardService implements CanActivate {
    isLoggedIn?: boolean;

    constructor(private router: Router,private notificationsSvc: NotificationsService,private transSvc: TranslocoService) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        if (this.isLoggedIn) {
            return true;
        }
        else {
            this.notificationsSvc.showError(this.transSvc.translate(TranslationKey.notAuthenticated));
            this.router.navigate(['/login']);
            return false;
        }
    }
}

@Injectable()
// Keeps an already-authenticated user off the login page. The wildcard route redirects EVERY
// unknown path to 'login', so this single guard also prevents authenticated shell from rendering behind the login view for those URLs.
export class LoginRouteGuardService implements CanActivate {
    constructor(private router: Router, private sessStorageSvc: SessionStorageService, private tokenSvc: TokenService) {
        this.sessStorageSvc.setKeyPrefix(AppConstants.STORAGE_KEY_PREFIX);
    }

    canActivate(): boolean {
        const authRes = this.sessStorageSvc.getItem(StorageKey.authResponse) as ITokenResponseData;
        const hasValidSession = !!authRes?.access_token && !this.tokenSvc.hasExpired(authRes.access_token);
        if (hasValidSession) {
            this.router.navigate(['/dashboard']);
            return false;
        }
        return true;
    }
}